const hostname = window.location.hostname;

const backendUrl =
  hostname === 'itp-ctc.hubruxelles.be'
    ? 'https://itp-ctc.hubruxelles.be'
    : hostname === 'stg-itp-ctc.hubruxelles.be'
      ? 'https://stg-itp-ctc.hubruxelles.be'
      : hostname === 'training-itp-ctc.hubruxelles.be'
        ? 'https://training-itp-ctc.hubruxelles.be'
        : hostname === 'wslhost'
          ? `http://wslhost:9950`
          : hostname === 'dckdmp8.res.hub.internal'
            ? `http://dckdmp8.res.hub.internal:9950`
            : `http://${hostname}:899`;

console.log('backendUrl : ', backendUrl);
// In development (localhost), use relative URL to leverage CRA proxy
// In production, use the full backend URL
const graphqlUri =
  hostname === 'localhost' ? '/graphql' : `${backendUrl}/graphql`;

// these will be included in the forms but hidden from the user. they're
// used for legacy reasons.
export const HIDDEN_ATTRIBUTES = [
  'icf_1_0_signed',
  'icf_1_1_signed',
  'icf_2_0_signed',
  'icf_3_0_signed',
  'icf_4_0_signed',
];

export const Settings = {
  MEDIA_URL: hostname === 'localhost' ? '/media/' : `${backendUrl}/media/`,
  ACCESS_TOKEN: 'aurora.accessToken',
  GRAPHQL_URI: graphqlUri,
  // LOGIN_URL: `${backendUrl}/accounts/google/login/`,
  HOME_PAGE: '/patients',
  BACKEND_URL: hostname === 'localhost' ? '' : backendUrl,
};
